<template>
  <div
    id="belts-selection"
    class="main-hovering-btn-layout fade-in"
    :class="{ shown: isData && !hideUi }"
  >
    <img
      class="btn hoverable-button white"
      :src="getPic('white')"
      handler-id="white"
      @mouseover="handleHoverEvent('white')"
      @mouseout="handleUnhoverEvent('white')"
      @click="handleActivateEventInComponent('white')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn hoverable-button yellow"
      :src="getPic('yellow')"
      handler-id="yellow"
      @mouseover="handleHoverEvent('yellow')"
      @mouseout="handleUnhoverEvent('yellow')"
      @click="handleActivateEventInComponent('yellow')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn hoverable-button orange"
      :src="getPic('orange')"
      handler-id="orange"
      @mouseover="handleHoverEvent('orange')"
      @mouseout="handleUnhoverEvent('orange')"
      @click="handleActivateEventInComponent('orange')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn hoverable-button green"
      :src="getPic('green')"
      handler-id="green"
      @mouseover="handleHoverEvent('green')"
      @mouseout="handleUnhoverEvent('green')"
      @click="handleActivateEventInComponent('green')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn hoverable-button blue"
      :src="getPic('blue')"
      handler-id="blue"
      @mouseover="handleHoverEvent('blue')"
      @mouseout="handleUnhoverEvent('blue')"
      @click="handleActivateEventInComponent('blue')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn hoverable-button black"
      :src="getPic('black')"
      handler-id="black"
      @mouseover="handleHoverEvent('black')"
      @mouseout="handleUnhoverEvent('black')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <img
      class="btn back back"
      :src="getPic('back')"
      handler-id="back"
      @mouseover="handleHoverEvent('back')"
      @mouseout="handleUnhoverEvent('back')"
      @click="handleActivateEvent('back')"
      @load="mixinsImgLoadHandler('belts-selection')"
    />
    <!-- handleActivateEvent -> mixins function! -->
    <audio
      ref="selectedSound"
      @loadeddata="mixinsImgLoadHandler('belts-selection')"
    >
      <source
        src="../assets/sound/belts_levels_selection.wav"
        type="audio/ogg"
      />
    </audio>
  </div>
</template>

<script>
import handHoverMixin from '../mixins/hand-hover-mixin.js';
import { eventTypes, soundDelay } from '../config/config';
import appConstants from '../config/constants';

export default {
  name: 'MainHoveringbtn',
  mixins: [handHoverMixin],
  props: {
    isData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hideUi: false,
      beltColor: null,
      eventTypes,
      btnClasses: {
        white: '',
        yellow: '',
        orange: '',
        green: '',
        blue: '',
        black: '',
        back: ''
      }
    };
  },
  mounted() {
    const beltColor = this.$route.params.beltColor;
    if (beltColor && appConstants.beltsArr.includes(beltColor)) {
      this.$store.dispatch('setBeltCodeLogic', beltColor);
      // when the player get a belt, then hes no longer on 'first time' mode.
      this.$store.commit('setFirstTimePlaying', false);
    }
  },
  methods: {
    getImgNameExta(handlerId) {
      if (
        // if not unlocked, add lock string to img require
        !this.$store.getters.getUnlockedBelts[handlerId] &&
        /* make sure its actually a belt (or black belt). */
        (appConstants.beltsArr.includes(handlerId) ||
          handlerId === appConstants.black)
      ) {
        return '_lock';
      }
      // if btn is being hovered, add hover string to rtequire
      if (this.btnClasses[handlerId] === appConstants.hover) {
        return '_' + appConstants.hover;
      }
      return '';
    },
    getPic(handlerId) {
      try {
        if (handlerId === appConstants.back) {
          // eslint-disable-next-line
          return require(`@/assets/img/btns/exit${this.getImgNameExta(handlerId)}.png`);
        }
        // eslint-disable-next-line
        return require(`@/assets/img/belts/${handlerId}${this.getImgNameExta(handlerId)}.png`);
      } catch (err) {
        console.warn({ err });
        return require('@/assets/img/btns/no.png');
      }
    },
    handleActivateEventInComponent(handlerId) {
      if (
        !this.hideUi &&
        appConstants.beltsArr.includes(handlerId) && // making sure handlerId is actually a belt
        this.$store.getters.getUnlockedBelts[handlerId] && // if this is false, belt is locked!
        handlerId !== appConstants.black
      ) {
        this.$refs.selectedSound.play();
        setTimeout(() => {
          // this route can only be routed with a belt color as a param.
          // if an event occours right after the user changed route, handlerId might be different ("one", for example)
          this.$router.push(`/levels-selection/${handlerId}`);
        }, soundDelay);
      }
    },
    navigateBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/belts_levels.scss';
</style>
